document.addEventListener("DOMContentLoaded", function () {
	var button = document.getElementById("info-block-more");
	var text = document.getElementById("info-block-text");

	if (!button || !text) {
		return;
	}

	var readMoreLabel = button.getAttribute("data-read-more") || "Read more";
	var readLessLabel = button.getAttribute("data-read-less") || "Read less";

	button.addEventListener("click", function () {
		var isExpanded = text.classList.toggle("is-expanded");
		button.setAttribute("aria-expanded", isExpanded ? "true" : "false");
		button.textContent = isExpanded ? readLessLabel : readMoreLabel;
	});
});
